export default function hasAllowedCharacters(value) {
  return new RegExp(/^[a-z\s\u00C0-\u017F-,.']+$/i).test(value);
}
